/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';
import { RequestBuilder } from '../request-builder';

import { BaseResponse } from '../models/base-response';

@Injectable({ providedIn: 'root' })
export class KeycloakHookService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `keycloakHookWebhook()` */
  static readonly KeycloakHookWebhookPath = '/api/modules/keycloak-ext/keycloak-hook-service/webhook';

  /**
   * Webhook.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `webhook()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  webhook$Response(
    params?: {
      body?: any
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<BaseResponse>> {
    const rb = new RequestBuilder(this.rootUrl, KeycloakHookService.KeycloakHookWebhookPath, 'post');
    if (params) {
      rb.body(params.body, 'application/*+json');
    }

    return this.http.request(
      rb.build({ responseType: 'json', accept: 'application/json', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<BaseResponse>;
      })
    );
  }

  /**
   * Webhook.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `webhook$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  webhook(
    params?: {
      body?: any
    },
    context?: HttpContext
  ): Observable<BaseResponse> {
    return this.webhook$Response(params, context).pipe(
      map((r: StrictHttpResponse<BaseResponse>): BaseResponse => r.body)
    );
  }

}
